var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mail-integration" } },
    [
      _c("AppBreadCrumb", {
        staticClass: "mail-integration-bread-crumb",
        attrs: {
          paths: [{ title: _vm.$t("chatbotv2.emailProvider") }],
          select: true,
        },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "main-integrations" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.emailProvider"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "integrations" }, [
          _c("span", { staticClass: "fix-align" }, [
            _c("span", { staticClass: "img" }, [
              _c("img", { attrs: { src: _vm.logoUrl } }),
            ]),
            _vm._v(" "),
            _c("span", [
              _c("div", { staticClass: "integration-name" }, [
                _vm._v(_vm._s(_vm.$t("mail.integrateYourMail"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "domain-name" }, [
                _vm._v(_vm._s(_vm.emailDomain)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.domainIsCreated && _vm.emailBtnEnabled
            ? _c("span", { staticClass: "fix-align" }, [
                _c("span", { staticClass: "material-icons done" }, [
                  _vm._v(" done "),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "connected-name" }, [
                  _vm._v(_vm._s(_vm.$t("settings.connected"))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.domainIsCreated && _vm.emailBtnEnabled
            ? _c("span", { staticClass: "fix-align" }, [
                _c(
                  "button",
                  {
                    staticClass: "connect-button",
                    on: { click: _vm.createDomain },
                  },
                  [
                    _c("span", { staticClass: "connect-name" }, [
                      _vm._v(_vm._s(_vm.$t("mail.connect"))),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.emailBtnEnabled
            ? _c("span", { staticClass: "fix-align" }, [_vm._m(0)])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "user-integrations" }, [
        _c("div", { staticClass: "user-email-name" }, [
          _vm._v(_vm._s(_vm.$t("akinon.userEmail"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "channels" },
          [
            _c(
              "div",
              {
                staticClass: "story channel-add",
                on: {
                  click: function ($event) {
                    return _vm.showModel()
                  },
                },
              },
              [
                _c("a-icon", {
                  staticStyle: { "font-size": "30px" },
                  attrs: { type: "plus-circle", theme: "filled" },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "text-large font-weight-bolder mt-2",
                    staticStyle: { "font-size": "15px" },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.addNewAddress")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.userEmailAddresses, function (userMailAddress) {
              return _c(
                "div",
                {
                  staticClass: "channel-item",
                  on: {
                    click: function ($event) {
                      return _vm.mailDetail(false, userMailAddress._id)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "icon-container" },
                    [
                      _c("MailIcon", {
                        staticStyle: { width: "40px", height: "40px" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "name-container" },
                    [
                      _c(
                        "a-tooltip",
                        {
                          attrs: {
                            title: _vm.getDepartmentName(userMailAddress._id),
                          },
                        },
                        [
                          _c("span", { staticClass: "user-name" }, [
                            _vm._v(
                              _vm._s(
                                _vm.user.name.length > 12
                                  ? _vm.user.name.substring(0, 12) + "..."
                                  : _vm.user.name
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-tooltip",
                        { attrs: { title: userMailAddress.mail } },
                        [
                          _c("span", { staticClass: "mail-name" }, [
                            _vm._v(
                              _vm._s(
                                userMailAddress.mail.length > 20
                                  ? userMailAddress.mail.substring(0, 20) +
                                      "..."
                                  : userMailAddress.mail
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "department-integrations" }, [
        _c("div", { staticClass: "department-title-name" }, [
          _vm._v(_vm._s(_vm.$t("mail.departmentMail"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "channels" },
          [
            _c(
              "div",
              {
                staticClass: "story",
                class:
                  _vm.departmentMailAddress.length !== _vm.subjects.total
                    ? "channel-add"
                    : "channel-add-disable",
                on: {
                  click: function ($event) {
                    return _vm.showModel(true)
                  },
                },
              },
              [
                _c("a-icon", {
                  staticStyle: { "font-size": "30px" },
                  attrs: { type: "plus-circle", theme: "filled" },
                }),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "text-large font-weight-bolder mt-2",
                    staticStyle: { "font-size": "15px" },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.addNewAddress")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.departmentMailAddress, function (department) {
              return _c(
                "div",
                {
                  staticClass: "channel-item",
                  on: {
                    click: function ($event) {
                      return _vm.mailDetail(true, department)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "icon-container" },
                    [
                      _c("MailIcon", {
                        staticStyle: { width: "40px", height: "40px" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "name-container" },
                    [
                      _c(
                        "a-tooltip",
                        { attrs: { title: _vm.getDepartmentName(department) } },
                        [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getDepartmentName(department).length > 12
                                  ? _vm
                                      .getDepartmentName(department)
                                      .substring(0, 12) + "..."
                                  : _vm.getDepartmentName(department)
                              )
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("a-tooltip", { attrs: { title: department.mail } }, [
                        _c("span", { staticClass: "mail-name" }, [
                          _vm._v(
                            _vm._s(
                              department.mail.length > 20
                                ? department.mail.substring(0, 20) + "..."
                                : department.mail
                            )
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.showCreateUserMail || _vm.showCreateDepartmentMail
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("mail.createMailAddress"),
                "class-name": "new-waba",
                showFooter: false,
              },
              on: {
                cancel: function ($event) {
                  return _vm.handleCancel()
                },
              },
            },
            [
              !!_vm.showCreateDepartmentMail
                ? _c(
                    "b-form-group",
                    {
                      staticClass: "form-group-departman",
                      attrs: {
                        label: _vm.$t("message.selectTopic"),
                        "label-for": "type-input",
                      },
                    },
                    [
                      _c(
                        "b-form-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'",
                            },
                          ],
                          attrs: {
                            id: "type-input",
                            "data-vv-as": _vm.$t("message.contentType"),
                            name: _vm.$t("message.contentType"),
                            type: "text",
                          },
                          model: {
                            value: _vm.selectedDepartmentId,
                            callback: function ($$v) {
                              _vm.selectedDepartmentId = $$v
                            },
                            expression: "selectedDepartmentId",
                          },
                        },
                        _vm._l(
                          _vm.getSelectDepartmentList(),
                          function (subject) {
                            return _c(
                              "option",
                              { domProps: { value: subject._id } },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(subject.languageContent.tr.name) +
                                    "\n                "
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { margin: "15px" } },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: {
                      "aria-disabled": _vm.userEmailAddresses.length !== 0,
                      "addon-after": "@" + _vm.emailDomain,
                      name: "channelName",
                    },
                    model: {
                      value: _vm.emailName,
                      callback: function ($$v) {
                        _vm.emailName = $$v
                      },
                      expression: "emailName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-footer" }, [
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c("a-button", { on: { click: _vm.handleCancel } }, [
                      _vm._v(_vm._s(_vm.$t("billing.cancel"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-button",
                      {
                        staticClass: "pr-confirm-btn",
                        attrs: {
                          type: "primary",
                          disabled:
                            !_vm.domainIsCreated || !_vm.emailBtnEnabled,
                        },
                        on: {
                          click: function ($event) {
                            !!_vm.showCreateDepartmentMail
                              ? _vm.createDepartment()
                              : _vm.createUserEmail()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("settings.create")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "connect-button disabled" }, [
      _c("span", { staticClass: "connect-name disabled" }, [
        _vm._v("LOADING.."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }